import { Form, Row } from "antd-v5";
import BaseModal from "components/BaseModal";
import message from "components/CustomMessage";
import dayjs from "dayjs";
import { filter, isArray, isUndefined, map, uniq } from "lodash";
import React, { forwardRef, useCallback } from "react";
import ExceptionAPI from "restAPI/ExceptionAPI";
import { ArmorcodeCustomField } from "types/tenantConfig";

import {
  ExceptionData,
  getFormRiskAssessmentFields,
} from "../ExceptionDetails/ExceptionDetailsUtils";

const MandatoryFieldsModal = forwardRef(
  (
    {
      riskAssessmentFields,
      exception,
      fetchProject,
      afterClose,
    }: {
      riskAssessmentFields: ArmorcodeCustomField[];
      exception: ExceptionData;
      fetchProject: () => void;
      afterClose: () => void;
    },
    ref,
  ) => {
    const [form] = Form.useForm();

    const handleSave = useCallback(async () => {
      await form.validateFields();

      try {
        //   setLoading(true);
        const data = form.getFieldsValue();
        const payload = {
          ...exception,
          //converted date to ISO string as API expects this
          startDate: new Date(exception.startDate).toISOString(),
          endDate: new Date(exception.endDate).toISOString(),
          approveByDate: new Date(exception.approveByDate).toISOString(),
        };
        const riskAssessmentFieldsArr = filter(
          map(Object.keys(data), (id) => {
            let values = data[id];
            if (dayjs.isDayjs(values)) {
              //format field Date
              values = values.format("YYYY-MM-DDTHH:mm:ss");
            }
            return {
              id,
              values: !isArray(values) ? [values] : values,
            };
          }),
          (fields) => !isUndefined(fields.values[0]),
        );
        //send previous fields if present
        payload.riskAssessmentFields = uniq([
          ...riskAssessmentFieldsArr,
          ...(exception.riskAssessmentFields || []),
        ]);
        await ExceptionAPI.update(exception.id, payload).promise;
        fetchProject();
        message.success("Risk assessment custom fields updated successfully");
      } catch (err) {
        console.error(err);
      }
    }, [form, exception, fetchProject]);

    const baseModalProps = {
      title: "Missing Required Fields",
      width: 521,
      onOk: handleSave,
      okText: "Save",
    };

    return (
      //@ts-ignore
      <BaseModal modalProps={baseModalProps} ref={ref} afterClose={afterClose}>
        <div className="text-section-subtitle">Missing Required Fields:</div>
        <Form
          layout="vertical"
          style={{ padding: "8px 24px" }}
          form={form}
          preserve={false}
        >
          <Row gutter={[16, 16]}>
            {getFormRiskAssessmentFields(riskAssessmentFields, 24)}
          </Row>
        </Form>
      </BaseModal>
    );
  },
);

export default MandatoryFieldsModal;
